import { render, staticRenderFns } from "./VIconArrowLeft.vue?vue&type=template&id=7fb4bfed&"
import script from "./VIconArrowLeft.vue?vue&type=script&lang=js&"
export * from "./VIconArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb4bfed')) {
      api.createRecord('7fb4bfed', component.options)
    } else {
      api.reload('7fb4bfed', component.options)
    }
    module.hot.accept("./VIconArrowLeft.vue?vue&type=template&id=7fb4bfed&", function () {
      api.rerender('7fb4bfed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VIcons/VIconArrowLeft.vue"
export default component.exports